import { useForm } from 'react-hook-form';
import { useState, useEffect, useRef } from 'react';
import { FormationService } from '../../../../../services/formationService';
import logger from '../../../../../utils/logger';


export const useEditSubmitForm = (formData, refetch, closeBootstrapModal, formationPlaceOptions, professorsFormatData, activeMembersLength, ChangeFormationPlace, consent = false) => {


  const initialValuesRef = useRef(null)

  //? funcion para preservar los datos actuales por defecto 
  const resetToInitialValues = () => {

    //?resetea todo el formulario
    // if (initialValuesRef.current) {
    //     reset(initialValuesRef.current);
    // }


    //? resetea solo un campo
    setValue(
      "formationPlaceId",
      initialValuesRef.current.formationPlaceId,
      {
        shouldDirty: false,
        shouldTouch: false,
        shouldValidate: false,
      }
    );
  }

  logger.debug('formData: ', formData)

  const [message, setMessage] = useState(null);
  const [response, setResponse] = useState(null);

  const { register, handleSubmit, control, formState: { errors }, reset, setValue } = useForm({
    mode: "onBlur",
    //? Estos valores son los "iniciales de los iniciales"
    defaultValues: {
      maxQuota: '',
      name: '',
      description: '',
      date: '',
      formationPlaceId: null, //? 👉 importante
      professors: null
    },
  })


  useEffect(() => {
    if (!formData) return;


    const selectedFormationPlace =
      formationPlaceOptions?.find(
        opt => opt.value === formData.formationPlaceId
      ) ?? null;

    const initialValues = {
      maxQuota: formData.maxQuota ?? 0,
      name: formData.name ?? '',
      description: formData.description ?? '',
      date: formData.date ? formData.date.split('T')[0] : '',
      formationPlaceId: selectedFormationPlace,
      professors: professorsFormatData
    };

    //? guardamos la "captura original
    initialValuesRef.current = initialValues;

    //? seteamos el formulario
    reset(initialValues);

  }, [formData, reset]);

  //console.log('radioOption: ', radioOption)


  const onSubmit = async (data) => {

    const newProfessors = data?.professors.map(profesor => profesor.label)

    

    //? si las formaciones son distintas y consent es falso, isChangingFormation = true 
    const isChangingFormation = formData?.formationPlaceId !== data?.formationPlaceId?.value && !consent;

    if (isChangingFormation) {
      logger.debug('se requiere consentimiento');
      ChangeFormationPlace();
      return;
    }


    const payload = {
      ...data,
      formationPlaceId: data.formationPlaceId?.value ?? null,
      professors: newProfessors,

      ...( formData?.formationPlaceId !== data?.formationPlaceId?.value &&consent && { confirmDeleteMembers: true })
    };


    try {



      if (payload.maxQuota < activeMembersLength) {

        logger.debug('payload validation: ', activeMembersLength < payload.maxQuota)

        const newResponse = {
          status: 400,
          message: 'El tamaño de la formacion no puede ser inferior a la cantidad actual de miembros participantes'

        }

        setResponse(newResponse);
        setMessage(newResponse.message);

      }

      else {
        const result = await FormationService.editFormation(
          formData.id,
          payload
        );

        setResponse(result);
        setMessage(result.message);
      }



    } catch (error) {
      setMessage(error.message);
      setResponse(error.status);

    }
  };



  return { register, handleSubmit, onSubmit, setValue, control, message, errors, response, resetToInitialValues }
}